import reducer from '../events/UserEventReducer';

class GameStore {
  constructor() {
    this.state = { user: null };
    this.listeners = new Set();
  }

  hydrate(user) {
    this.state = { ...this.state, user };
    this._emit();
  }

  getState() {
    return this.state;
  }

  subscribe(fn) {
    this.listeners.add(fn);
    return () => this.listeners.delete(fn);
  }

  dispatch(evt) {
    if (!this.state.user) return; // not ready yet
    const nextUser = reducer(this.state.user, evt);
    if (nextUser !== this.state.user) {
      this.state = { ...this.state, user: nextUser };
      this._emit();
    }
  }

  _emit() {
    for (const fn of this.listeners) {
      try { fn(this.state); } catch (e) { console.error('Store listener error', e); }
    }
  }
}

const gameStore = new GameStore();
export default gameStore;

